import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

@Injectable()
export class UserService {

  private userReplaySubject = new ReplaySubject(1);
  private UUID: string;

  public addUser(user: any) {
    this.userReplaySubject.next(user);
  }

  public setUserUUID(UUID: string) {
    this.UUID = UUID;
  }

  public getUserUUID() {
    return this.UUID;
  }
}
